<meeting-scheduler-duration-multi-select
  [options]="options"
  [duration]="noticeTime"
  [title]="'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.NOTICE_TIME.TITLE' | translate"
  [description]="'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.NOTICE_TIME.DESCRIPTION' | translate"
  (durationSelected)="onDurationSelected($event)"
></meeting-scheduler-duration-multi-select>
